const menu = require('./menu.svg')
const leftArrow = require('./leftArrow.svg')

export {
  menu,
  leftArrow
}